import type { PriceModel, SortKey } from "./types";

export { monthlyCost } from "../shared/pricing";
import { monthlyCost } from "../shared/pricing";

export function formatMoney(value: number, locale = "en-US") {
  const digits = value < 1 ? 3 : value < 100 ? 2 : 0;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatTokens(value: number) {
  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    return `${Number.isInteger(millions) ? millions : millions.toFixed(1)}M`;
  }
  if (value >= 1_000) return `${Math.round(value / 1_000)}K`;
  return String(value);
}

export function sortModels(
  models: PriceModel[],
  sort: SortKey,
  inputMillions: number,
  outputMillions: number,
  cachePercent: number,
) {
  return [...models].sort((a, b) => {
    if (sort === "monthly") {
      return (
        monthlyCost(a, inputMillions, outputMillions, cachePercent) -
        monthlyCost(b, inputMillions, outputMillions, cachePercent)
      );
    }
    if (sort === "input") return a.cost.input - b.cost.input;
    if (sort === "output") return a.cost.output - b.cost.output;
    if (sort === "context") return b.context - a.context;
    return (b.releaseDate ?? "").localeCompare(a.releaseDate ?? "");
  });
}

export function getInitialNumber(key: string, fallback: number) {
  const value = new URLSearchParams(window.location.search).get(key);
  if (value === null) return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
}
